<template>
  <v-card class="my-3">
    <v-card-title primary-title>
      <h3 class="headline">Agreements</h3>      
    </v-card-title>
    <v-card-text>
      Agreements must be acknowledged by the student before a placement is logged.            
    </v-card-text>
    <v-list 
      three-line
      subheader>
      <draggable 
        :list="agreements" 
        :options="{handle:'.v-icon'}"
        @end="onEnd">
        <v-list-tile 
          v-for="item in agreements" 
          :key="item.key"      
          @click="openAgreement(item)">
          <v-list-tile-action>
            <v-icon>drag_handle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-layout 
              align-center >
              <v-checkbox
                hide-details
                disabled
                color="success"
              >
                <label 
                  slot="label" 
                  v-html="item.html"/>
              </v-checkbox>
            </v-layout>
          </v-list-tile-content>
        </v-list-tile>
      </draggable>
    </v-list>
    <v-card-text>
      <v-dialog 
        v-model="dialog" 
        persistent 
        max-width="500px">
        <v-fab-transition slot="activator">
          <v-btn
            slot="activator"
            color="secondary"
            fab
            dark
            absolute
            bottom
            right            
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-card>
          <v-form 
            ref="form"
            v-model="valid"              
            lazy-validation>
            <v-toolbar 
              color="primary" 
              dark>
              <v-toolbar-title>
                <span class="headline">Add Agreement</span>
              </v-toolbar-title>
            </v-toolbar>              
            <v-card-text>
              <ckeditor 
                :editor="editor" 
                v-model="item.html" 
                :config="editorConfig"/>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-spacer/>
              <v-btn 
                color="primary" 
                flat 
                @click.native="close">Close</v-btn>
              <v-btn 
                v-if="item.itemOrder" 
                color="red darken-1" 
                flat 
                @click.native="remove(item)">Delete</v-btn>
              <v-btn 
                v-if="item.itemOrder" 
                color="primary" 
                flat 
                @click.native="update(item)">Update</v-btn>              
              <v-btn 
                v-else 
                color="primary" 
                flat 
                @click.native="save(item)">Save</v-btn>
            </v-card-actions>
          </v-divider></v-form>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import draggable from "vuedraggable";

export default {
  name: "Agreements",
  data: () => ({
    dialog: false,
    valid: true,
    agreements: null,
    item: {
      html: "",
      itemOrder: null,
      ".key": null
    },
    editor: ClassicEditor,
    editorConfig: {
      toolbar: ["bold", "italic", "link"]
    }
  }),
  components: {
    ckeditor: CKEditor.component,
    draggable
  },
  firestore() {
    return {
      agreements: this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
        .collection("agreements")
        .orderBy("itemOrder")
    };
  },
  methods: {
    onEnd(evt) {
      this.$store.dispatch("setLoading", true);
      var batch = this.$store.getters.db.batch();
      this.agreements.forEach((element, index) => {
        let ref = this.$store.getters.db
          .collection("courses")
          .doc(this.$route.params.course)
          .collection("units")
          .doc(this.$route.params.unit)
          .collection("agreements")
          .doc(element[".key"]);
        batch.update(ref, { itemOrder: +index + 1 });
      });

      batch.commit().then(() => {
        this.$store.dispatch("setLoading", false);
      });
    },
    save({ itemOrder, html }) {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        this.$store.dispatch("setLoading", true);
        itemOrder = +this.agreements.length + 1;
        this.$store.getters.db
          .collection("courses")
          .doc(this.$route.params.course)
          .collection("units")
          .doc(this.$route.params.unit)
          .collection("agreements")
          .add({ itemOrder, html })
          .then(function() {
            console.log("Document successfully written!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "Agreement added"
            });
            self.$store.dispatch("setLoading", false);
            self.item.html = "";
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            self.$store.dispatch("setLoading", false);
            self.item.html = "";
          });
      }
    },
    update(agreement) {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        this.$store.dispatch("setLoading", true);
        this.$store.getters.db
          .collection("courses")
          .doc(this.$route.params.course)
          .collection("units")
          .doc(this.$route.params.unit)
          .collection("agreements")
          .doc(agreement[".key"])
          .update({ html: agreement.html })
          .then(function() {
            console.log("Document successfully updated!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "Agreement updated"
            });
            self.$store.dispatch("setLoading", false);
            self.$refs.form.reset();
            self.item.html = "";
            self.item.itemOrder = null;
            self.item[".key"] = null;
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            self.$store.dispatch("setLoading", false);
            self.$refs.form.reset();
            self.item.html = "";
            self.item.itemOrder = null;
            self.item[".key"] = null;
          });
      }
    },
    remove(agreement) {
      let self = this;
      this.dialog = false;
      this.$store.dispatch("setLoading", true);
      this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
        .collection("agreements")
        .doc(agreement[".key"])
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          self.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "error",
            timeout: 6000,
            text: "Agreement removed"
          });
          self.$store.dispatch("setLoading", false);
          self.item.html = "";
          self.item.itemOrder = null;
          self.item[".key"] = null;
          self.$refs.form.reset();
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
          self.$store.dispatch("setLoading", false);
          self.item.html = "";
          self.item.itemOrder = null;
          self.item[".key"] = null;
          self.$refs.form.reset();
        });
    },
    close() {
      this.item.html = "";
      this.item.itemOrder = null;
      this.item[".key"] = null;
      this.dialog = false;
      this.$store.dispatch("sendNotification", {
        snackbar: true,
        color: "warning",
        text: "Agreement not saved"
      });
      this.$refs.form.reset();
    },
    openAgreement(agreement) {
      console.log(agreement);
      this.item = JSON.parse(JSON.stringify(agreement));
      this.dialog = true;
    }
  }
};
</script>
